// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"XR-z","carouselContainer":"YR-z"};